import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Returns true on phone-class viewports (< 600px wide).
 *
 * Use this for layout decisions that need to differ between phone and tablet/desktop:
 * - `fullScreen={useIsMobile()}` on Dialogs
 * - `direction={useIsMobile() ? 'column' : 'row'}` on action Stacks
 * - Conditional rendering of Drawer vs. Menu in the Header
 *
 * For finer control prefer MUI's `sx={{ display: { xs: 'none', sm: 'block' } }}`
 * or `<Stack direction={{ xs: 'column', sm: 'row' }}>` patterns directly — those
 * stay reactive without re-rendering on every breakpoint cross.
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

/** Returns true on tablet-or-narrower (< 900px wide). Useful for table → cards switches. */
export function useIsNarrow(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
